import ObjectID from 'bson-objectid'

// import { customAlphabet } from 'nanoid'
// const nanoid = customAlphabet(`0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz`, 13)

export function ObjectId(): string {
  return typeof process !== `undefined` && process.env.TESTING ? `test-` + String(ObjectID()) : String(ObjectID())
}
